import 'regenerator-runtime/runtime';
import React, { useState } from 'react'
import { useAsyncDebounce } from 'react-table'
import { ReactComponent as SearchIcon } from "@icons/search.svg"
import Input from '@blocks/Input'
import { tablet } from '@styles/mixins'
import styled, { css } from 'styled-components'
import { useTableContext } from '../context';

const Search = () => {
    const { state, setGlobalFilter } = useTableContext()

    const [value, setValue] = useState<string>(state?.globalFilter)
    const updateGlobalFilter = useAsyncDebounce(search => setGlobalFilter(search || undefined), 200)

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setValue(value)
        updateGlobalFilter(value)
    }

    return (
        <Wrapper>
            <Input
                id="search"
                name="search"
                value={value || ""}
                height="l"
                placeholder="By Column"
                icon={<SearchIcon />}
                onChange={onChange} />
        </Wrapper>
    )
}

export default React.memo(Search)

const Wrapper = styled.div`
    width: 100%;
    position: relative;
    
    ${tablet(css`
        min-width: 250px;
        max-width: 250px;
    `)}
`

